import { render, staticRenderFns } from "./TemplateEditorSubject.vue?vue&type=template&id=31158c6f&scoped=true"
import script from "./TemplateEditorSubject.vue?vue&type=script&lang=ts"
export * from "./TemplateEditorSubject.vue?vue&type=script&lang=ts"
import style0 from "./TemplateEditorSubject.vue?vue&type=style&index=0&id=31158c6f&prod&scoped=true&lang=css"
import style1 from "./TemplateEditorSubject.vue?vue&type=style&index=1&id=31158c6f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31158c6f",
  null
  
)

export default component.exports